import { ArtDerFahrt, Befehl, Standort } from '@repo/ui'

export type Befehlsnachricht = {
  id: string
  zugnummer: number
  artDerFahrt: ArtDerFahrt
  eindeutigeKennung: string
  status: BfnStatus
  visuellerStatus: string
  statusTimestamps: BfnStatusTimestamp[]
  fdlName: string
  fdlArbeitsplatz: string
  fdlArbeitsplatzOrt: string
  versandzeitpunkt: Date
  bearbeitbarBis: Date
  quittierungsdatum: Date | null
  standort: Standort | null
  befehle: Befehl[]
  hash1: string
  hash2: string | null
  eindeutigeKennungHash: string
  statusTfHash: string
  standortHash: string | null
}

export interface BfnStatusTimestamp {
  status: BfnStatus
  time: Date
  visuellerStatus: string
}

export enum BfnStatus {
  ERSTELLT = 'ERSTELLT',
  SMS_IM_VERSAND = 'SMS_IM_VERSAND',
  SMS_VERSAND_ABGEBROCHEN = 'SMS_VERSAND_ABGEBROCHEN',
  SMS_ZUGESTELLT = 'SMS_ZUGESTELLT',
  ERSTABRUF_GESTARTET = 'ERSTABRUF_GESTARTET',
  STANDORTABGLEICH_DURCH_FDL_ERFORDERLICH = 'STANDORTABGLEICH_DURCH_FDL_ERFORDERLICH',
  STANDORTBESTAETIGUNG_DURCH_TF_ERFORDERLICH = 'STANDORTBESTAETIGUNG_DURCH_TF_ERFORDERLICH',
  STANDORTEINGABE_AKZEPTIERT = 'STANDORTEINGABE_AKZEPTIERT',
  STANDORTABGLEICH_FEHLGESCHLAGEN = 'STANDORTABGLEICH_FEHLGESCHLAGEN',
  ABGERUFEN = 'ABGERUFEN',
  QUITTIERT = 'QUITTIERT',
  ERLEDIGT = 'ERLEDIGT',
  ABGEWIESEN = 'ABGEWIESEN',
  GELOESCHT = 'GELOESCHT',
  WIDERRUFEN = 'WIDERRUFEN'
}
